<template>
	<v-col class="transaction-serial">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Laporan Transaksi Serial</div>
		</div>
		<div class="pt-1 pb-2 d-flex flex-wrap font-size-10 grey--text">
			<v-icon small color="grey">mdi-credit-card-plus</v-icon>
			<div class="pl-2">Transaksi Serial</div>
			<div class="px-2">/</div>
			<div>Laporan Transaksi Serial</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider" v-model="currentTabs">
							<v-tab @click="getShowSerial('registrasi')">Serial Registrasi</v-tab>
							<v-tab @click="getShowSerial('aktivasi')">Serial Aktivasi</v-tab>
							<v-tab @click="getShowSerial('upgrade')">Serial Upgrade</v-tab>
							<v-tab @click="getShowSerial('ro')">Serial RO</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'registrasi'">
					<SerialRegistration></SerialRegistration>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'aktivasi'">
					<SerialActivation></SerialActivation>
				</div>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'upgrade'">
					<SerialUpgrade></SerialUpgrade>
				</div>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'ro'">
					<SerialRO></SerialRO>
				</div>
			</v-scroll-x-transition>
		</div>
	</v-col>
</template>

<script>
import SerialRegistration from './serialRegistration/SerialRegistration';
import SerialActivation from './serialActivation/SerialActivation';
import SerialUpgrade from './serialUpgrade/SerialUpgrade';
import SerialRO from './serialRO/SerialRO';

export default {
	components: {
		SerialRegistration, SerialActivation, SerialUpgrade, SerialRO
	},
	data() {
		return {
			showSerial: 'registrasi',
			currentTabs: 0,
		}
	},
	methods: {
		getData() {
			if (this.$route.params.type) {
				if (this.$route.params.type === "registrasi") {
					this.currentTabs = 0
					this.showSerial = this.$route.params.type
				}
				else if (this.$route.params.type === "aktivasi") {
					this.currentTabs = 1
					this.showSerial = this.$route.params.type
				}
				else if (this.$route.params.type === "upgrade") {
					this.currentTabs = 2
					this.showSerial = this.$route.params.type
				}
				else if (this.$route.params.type === "ro") {
					this.currentTabs = 3
					this.showSerial = this.$route.params.type
				}
				else this.$router.push({ name: 'not-found' })
			}
		},
		getShowSerial(val) {
			if (val == 'registrasi') {
				this.$router.push({ params: { type: val } })
				this.showSerial = this.$route.params.type
			}
			if (val == 'aktivasi') {
				this.$router.push({ params: { type: val } })
				this.showSerial = this.$route.params.type
			}
			if (val == 'upgrade') {
				this.$router.push({ params: { type: val } })
				this.showSerial = this.$route.params.type
			}
			if (val == 'ro') {
				this.$router.push({ params: { type: val } })
				this.showSerial = this.$route.params.type
			}
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Laporan Transaksi Serial`)
		this.getData()
	}
};
</script>